import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const ChartsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const agentCounts = useCallback(async (props) => {
        await execute({ scope: 'agentCounts', url: `Charts/Agents/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const hireSevers = useCallback(async (props) => {
        await execute({ scope: 'hireSevers', url: `Charts/Agents/HireSevers/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const listingCounts = useCallback(async (props) => {
        await execute({ scope: 'listingCounts', url: `Charts/Listings/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const top10AgentVolume = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10AgentVolume', url: `Charts/Agents/TopVolume/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const top10AgentGCI = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10AgentGCI', url: `Charts/Agents/TopGCI/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const top10AgentSides = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10AgentSides', url: `Charts/Agents/TopSides/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const top10TeamVolume = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10TeamVolume', url: `Charts/Teams/TopVolume/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const top10TeamGCI = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10TeamGCI', url: `Charts/Teams/TopGCI/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const top10TeamSides = useCallback(async (props) => {
        const page = !_.isNumber(props.page) ? 0 : props.page;

        await execute({ scope: 'top10TeamSides', url: `Charts/Teams/TopSides/${props.franchiseId}?startDate=${props.startDate}&endDate=${props.endDate}&page=${page}`, method: 'GET', secure: true });
    }, [execute]);

    const dailyStats = useCallback(async (props) => {
        await execute({ scope: 'dailyStats', url: `Charts/Franchise/DailyStats/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const sidesCounts = useCallback(async (props) => {
        await execute({ scope: 'sidesCounts', url: `Charts/Sides/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const salesCounts = useCallback(async (props) => {
        await execute({ scope: 'salesCounts', url: `Charts/Sales/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const pendingSalesCounts = useCallback(async (props) => {
        await execute({ scope: 'pendingSalesCounts', url: `Charts/Pending/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const contractCounts = useCallback(async (props) => {
        await execute({ scope: 'contractCounts', url: `Charts/Contracts/Counts/${props.franchiseId}?timeframe=${props.timeframe}`, method: 'GET', secure: true });
    }, [execute]);

    const value = { agentCounts, hireSevers, listingCounts, top10AgentVolume, top10AgentSides, top10AgentGCI, dailyStats, sidesCounts,
        salesCounts, pendingSalesCounts, contractCounts, top10TeamVolume, top10TeamSides, top10TeamGCI, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useChartsStore = () => React.useContext(Context);
